<template>
  <div class="quan-ly-thiet-bi otp-scope p-1">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h4 class="otp-page-title mb-0">Thiết bị xác thực 2 bước</h4>
      <!-- UC7.4 port QTHT: thêm thiết bị dự phòng qua QR handoff (app eDoc quét). Truyền devices để
           modal chọn branch add (>=1 Active, gate OTP) vs enroll (0-factor). THAY register-device cổ điển
           (đã verify LIVE cả 2 nhánh + regression + reachability nso PROD 260824). -->
      <b-button variant="primary" class="btn-otp-register" @click="moThemThietBiQr">Thêm thiết bị</b-button>
    </div>

    <b-table
      :items="devices"
      :fields="fields"
      responsive
      bordered
      show-empty
      empty-text="Chưa có thiết bị nào được đăng ký."
      head-variant="light"
      class="table-thiet-bi"
    >
      <template #cell(state)="row">
        <b-badge :variant="stateVariant(row.item.state)">
          {{ stateLabel(row.item.state) }}
        </b-badge>
      </template>
      <template #cell(isPrimary)="row">
        <!-- Nhãn vai trò đầy đủ đồng bộ màn self QLVB (ModalQuanLyThietBiCuaToi.vue) + màn admin
             (ModalQuanLyThietBiUser.vue): primary="Thiết bị chính"; non-primary="Thiết bị dự phòng". -->
        <span v-if="row.item.isPrimary" class="text-success font-weight-bold text-nowrap"
          >✔ Thiết bị chính</span
        >
        <span v-else class="text-muted text-nowrap">Thiết bị dự phòng</span>
      </template>
      <template #cell(lanDungCuoi)="row">
        {{ formatDate(row.item.lanDungCuoi) }}
      </template>
      <!-- GAP 7.4: nút Đặt-làm-chính chỉ hiện với TB Active (state=1) chưa primary. -->
      <template #cell(hanhDong)="row">
        <b-button
          v-if="row.item.state === 1 && !row.item.isPrimary"
          size="sm"
          variant="outline-primary"
          @click="xacNhanDatChinh(row.item)"
        >
          Đặt làm chính
        </b-button>
      </template>
    </b-table>

    <ModalThemThietBiQr ref="modalThemQr" @added="taiDanhSach" />
    <BaseLoading :is-loading="isLoading" />
  </div>
</template>

<script>
import ModalThemThietBiQr from "@/components/pages/quan-tri-he-thong/ModalThemThietBiQr";
import BaseLoading from "@/components/common/BaseLoading";
import { setBreadcrumb } from "@/utils/commonUtils";
import { MENU_ROUTE_NAME } from "@/constants/constants";

// Phase 5b-2: màn quản lý thiết bị 2FA (post-login). Hiển danh sách + mở modal đăng ký/kích hoạt.
export default {
  name: "TrangQuanLyThietBi",
  components: { ModalThemThietBiQr, BaseLoading },
  data() {
    return {
      devices: [],
      isLoading: false,
      // Key khớp camelCase response BE (verify HTTP thật: pipeline serialize camelCase, giống mọi endpoint cũ).
      fields: [
        { key: "tenThietBi", label: "Tên thiết bị" },
        { key: "os", label: "Hệ điều hành" },
        { key: "state", label: "Trạng thái" },
        { key: "isPrimary", label: "Chính" },
        { key: "lanDungCuoi", label: "Dùng lần cuối" },
        { key: "hanhDong", label: "Hành động" },
      ],
    };
  },
  created() {
    setBreadcrumb(
      `${MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.NAME} / ${MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.THIET_BI.NAME}`
    );
    this.taiDanhSach();
  },
  methods: {
    taiDanhSach() {
      this.isLoading = true;
      this.$store
        .dispatch("common/listDevice")
        .then((res) => {
          this.isLoading = false;
          // ServiceResponse serialize camelCase (verify HTTP thật): envelope .data = mảng device.
          this.devices = (res && res.data) || [];
        })
        .catch((error) => {
          this.isLoading = false;
          this.$toasted.global.showErrorMessage({
            message: (error && error.data && error.data.message) || "Không tải được danh sách thiết bị",
          });
        });
    },
    // UC7.4 port QTHT: mở modal thêm thiết bị QR. Truyền devices để modal chọn branch add vs enroll.
    moThemThietBiQr() {
      this.$refs.modalThemQr.showModal(this.devices);
    },
    // GAP 7.4: xác nhận rồi đặt thiết bị làm chính. Body { deviceId } camelCase -> BE set-primary
    // (invariant đúng-1-primary atomic). Xong -> tải lại danh sách để ✔ chuyển đúng.
    xacNhanDatChinh(item) {
      this.$bvModal
        .msgBoxConfirm(
          `Đặt "${item.tenThietBi || "thiết bị này"}" làm thiết bị chính?`,
          {
            title: "Xác nhận",
            okTitle: "Đồng ý",
            cancelTitle: "Huỷ",
            centered: true,
          }
        )
        .then((ok) => {
          if (ok) this.datLamChinh(item.deviceId);
        });
    },
    datLamChinh(deviceId) {
      this.isLoading = true;
      this.$store
        .dispatch("common/setPrimary", deviceId)
        .then((res) => {
          this.isLoading = false;
          if (res && res.succeeded) {
            this.$toasted.clear();
            this.$toasted.global.showSuccessMessage({
              message: "Đã đặt thiết bị chính",
            });
            this.taiDanhSach();
          } else {
            this.$toasted.global.showErrorMessage({
              message: (res && res.message) || "Không đặt được thiết bị chính",
            });
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.$toasted.global.showErrorMessage({
            message:
              (error && error.data && error.data.message) ||
              "Không đặt được thiết bị chính",
          });
        });
    },
    // Map enum DeviceState (BE): 0=ChoKichHoat, 1=Active, 2=Locked, 3=DaHuyKichHoat (UC7.5 soft-state).
    stateLabel(state) {
      return { 0: "Chờ kích hoạt", 1: "Đang hoạt động", 2: "Đã khoá", 3: "Đã hủy" }[state] || "Không rõ";
    },
    stateVariant(state) {
      return { 0: "warning", 1: "success", 2: "danger", 3: "secondary" }[state] || "secondary";
    },
    formatDate(value) {
      if (!value) return "";
      const d = new Date(value);
      return isNaN(d.getTime()) ? "" : d.toLocaleString("vi-VN");
    },
  },
};
</script>

<style lang="scss" scoped>
// Reskin OTP (Phase 3): overlay token + typography + badge trạng thái. State machine (v-if nút set-primary) giữ nguyên.
.quan-ly-thiet-bi {
  background: var(--otp-surface);
  font-family: var(--otp-sans);
  color: var(--otp-ink);

  .otp-page-title {
    font-family: var(--otp-display);
    font-weight: 600;
    font-size: 20px;
    color: var(--otp-ink);
  }
}

// Bảng thiết bị: header token, badge trạng thái map màu semantic theo variant (giữ stateVariant script).
::v-deep .table-thiet-bi {
  thead th {
    background-color: var(--otp-surface-2) !important;
    color: var(--otp-ink) !important;
    font-weight: 600;
    vertical-align: middle;
    border-color: var(--otp-border);
  }
  td {
    color: var(--otp-ink);
    border-color: var(--otp-border);
    vertical-align: middle;
  }

  // Badge trạng thái: overlay màu token lên bootstrap variant (0=warning,1=success,2=danger,3=secondary).
  .badge {
    font-size: 12px;
    font-weight: 600;
    padding: 4px 10px;
    border-radius: 20px;
    &.badge-success {
      background: var(--otp-success-bg);
      color: var(--otp-success);
    }
    &.badge-warning {
      background: var(--otp-warning-bg);
      color: var(--otp-warning);
    }
    &.badge-danger {
      background: var(--otp-danger-bg);
      color: var(--otp-danger);
    }
    &.badge-secondary {
      background: var(--otp-surface-2);
      color: var(--otp-muted);
    }
  }
}
</style>
